<script>
  export let max, stat, val, mod = 1, className = ''

  import Icon from '@iconify/svelte'
  import { Chevron as Priority } from '$icons'

  let c
  if (val < 50) c = 'poor'
  else if (val < 80) c = 'meh'
  else if (val < 100) c = 'okay'
  else if (val < 120) c = 'good'
  else c = 'great'

</script>

<span
  class='col-span-2 flex justify-end items-center sm:col-span-2 text-xs text-right {className}'
  class:pos={mod > 1}
  class:neg={mod < 1}
  data-stat={stat}
>
    {#if mod !== 1}
      <Icon inline={true} class='fill-current {mod < 1 ? 'transform rotate-180' : ''}' icon={Priority} />
    {/if}
</span>

<span data-val={val} class='{c} {className} transition col-span-3 sm:col-span-1 -ml-1 font-bold text-xs text-right'></span>
<div style='width: {100 * val / max}%' class='{c} {className} transition col-span-5 sm:col-span-4 h-2 rounded-md ring-2' />

<style lang="postcss">

  .neg { color: theme('colors.blue.400'); }
  .pos { color: theme('colors.orange.600'); }
  :global(.dark) .neg { color: theme('colors.blue.300'); }
  :global(.dark) .pos { color: theme('colors.orange.300'); }

  .poor { --stat-col: theme('colors.red.300'); --stat-col-ring: theme('colors.red.100'); }
  .meh { --stat-col: theme('colors.orange.300'); --stat-col-ring: theme('colors.orange.100'); }
  .okay { --stat-col: theme('colors.yellow.300'); --stat-col-ring: theme('colors.yellow.100'); }
  .good { --stat-col: theme('colors.lime.300'); --stat-col-ring: theme('colors.lime.100'); }
  .great { --stat-col: theme('colors.green.300'); --stat-col-ring: theme('colors.green.100'); }

  :global(.dark) .great { --stat-col: theme('colors.green.600'); --stat-col-ring: theme('colors.green.400'); }
  :global(.dark) .good { --stat-col: theme('colors.lime.600'); --stat-col-ring: theme('colors.lime.400'); }
  :global(.dark) .okay { --stat-col: theme('colors.yellow.600'); --stat-col-ring: theme('colors.yellow.400'); }
  :global(.dark) .meh { --stat-col: theme('colors.orange.600'); --stat-col-ring: theme('colors.orange.400'); }
  :global(.dark) .poor { --stat-col: theme('colors.red.600'); --stat-col-ring: theme('colors.red.400'); }

  div {
    background-color: var(--stat-col);
    --tw-ring-color: var(--stat-col-ring);
  }

  span[data-stat]::after {
    content: attr(data-stat);
  }

  span[data-val]::after {
    content: attr(data-val);
  }

  span { color: var(--stat-col); }
  :global(.dark) span { color: var(--stat-col-ring); }

</style>
